// © Microsoft Corporation. All rights reserved.

/**
 * The base URL for loading CMS images via CDN. Follows the format: //[host]/tenant/amp/entityid/.
 * The content ID and image service parameters can be appended to the end to form the final URL.
 */
export const ImageServiceConfig = {
    prod: "//img-s-msn-com.akamaized.net/tenant/amp/entityid/"
};
